import { useSyncExternalStore } from 'react';

/**
 * Tailwind `xl`(1280px) 미만 — 사이드바를 서랍(drawer)으로 바꾸는 기준.
 * 휴대폰뿐 아니라 태블릿(가로 모드 포함, iPad Pro 11" 가로 1194px)까지 모바일 레이아웃으로 본다.
 */
export const MOBILE_LAYOUT_QUERY = '(max-width: 1279.98px)';

const canMatchMedia = () =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function';

/**
 * CSS 미디어 쿼리 일치 여부를 구독한다.
 * matchMedia가 없는 환경(jsdom 테스트 등)에서는 항상 false — 데스크톱 레이아웃으로 그린다.
 */
export const useMediaQuery = (query: string) =>
  useSyncExternalStore(
    (onChange) => {
      if (!canMatchMedia()) return () => {};
      const mql = window.matchMedia(query);
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    },
    () => (canMatchMedia() ? window.matchMedia(query).matches : false),
    () => false,
  );

export const useIsMobileLayout = () => useMediaQuery(MOBILE_LAYOUT_QUERY);
